import { FormattedMessage } from "react-intl";
import React from "react";
import ExplanExportImg from "../../../../../images/home_explain_export_import/home_explain_export_import.png";
import ExplanExportImg2x from "../../../../../images/home_explain_export_import/home_explain_export_import@2x.png";
import ExplanExportImg3x from "../../../../../images/home_explain_export_import/home_explain_export_import@3x.png";
import ExplanDatasetImg from "../../../../../images/home_explain_multi_dataset/home_explain_multi_dataset.png";
import ExplanDatasetImg2x from "../../../../../images/home_explain_multi_dataset/home_explain_multi_dataset@2x.png";
import ExplanDatasetImg3x from "../../../../../images/home_explain_multi_dataset/home_explain_multi_dataset@3x.png";
import ExplanAnalyticsImg from "../../../../../images/home_explain_analytics/home_explain_analytics.png";
import ExplanAnalyticsImg2x from "../../../../../images/home_explain_analytics/home_explain_analytics@2x.png";
import ExplanAnalyticsImg3x from "../../../../../images/home_explain_analytics/home_explain_analytics@3x.png";
//

export const featureIntroSetting = [
  {
    direction: "left",
    bgColor: "yellow",
    tag: (
      <FormattedMessage
        id="home.feature.intro.export.import.tag"
        defaultMessage="檔案傳輸"
      />
    ),
    title: (
      <FormattedMessage
        id="home.feature.intro.export.import.title"
        defaultMessage="輕鬆匯入，即時生產"
      />
    ),
    content: (
      <FormattedMessage
        id="home.feature.intro.export.import.introduction"
        defaultMessage="上傳個人資料集、匯出檔案以利網絡分析軟體進一步分析"
      />
    ),
    imgSrc: ExplanExportImg,
    imgSrcSet: `${ExplanExportImg} 1x,${ExplanExportImg2x} 2x,${ExplanExportImg3x} 3x`,
  },
  {
    direction: "right",
    bgColor: "orange",
    tag: (
      <FormattedMessage
        id="home.feature.intro.multi.dataset.tag"
        defaultMessage="資料集"
      />
    ),
    title: (
      <FormattedMessage
        id="home.feature.intro.multi.dataset.title"
        defaultMessage="跨文本串連"
      />
    ),
    content: (
      <FormattedMessage
        id="home.feature.intro.multi.dataset.introduction"
        defaultMessage="探討多文本中的人物之間的互動，並顯示網絡圖"
      />
    ),
    imgSrc: ExplanDatasetImg,
    imgSrcSet: `${ExplanDatasetImg} 1x,${ExplanDatasetImg2x} 2x,${ExplanDatasetImg3x} 3x`,
  },
  {
    direction: "left",
    bgColor: "blue",
    tag: (
      <FormattedMessage
        id="home.feature.intro.analytics.tag"
        defaultMessage="數據分析"
      />
    ),
    title: (
      <FormattedMessage
        id="home.feature.intro.analytics.title"
        defaultMessage="多樣的數據分析工具"
      />
    ),
    content: (
      <FormattedMessage
        id="home.feature.intro.analytics.introduction"
        defaultMessage="將網絡圖以數據分析呈現，提供更多視角檢視網絡"
      />
    ),
    imgSrc: ExplanAnalyticsImg,
    imgSrcSet: `${ExplanAnalyticsImg} 1x,${ExplanAnalyticsImg2x} 2x,${ExplanAnalyticsImg3x} 3x`,
  },
];
